module.exports = __webpack_public_path__ + "img/2.0ad6aea5.png";